import { render, staticRenderFns } from "./_base-priority-picker.vue?vue&type=template&id=1b0af5ee&scoped=true&"
import script from "./_base-priority-picker.vue?vue&type=script&lang=js&"
export * from "./_base-priority-picker.vue?vue&type=script&lang=js&"
import style0 from "./_base-priority-picker.vue?vue&type=style&index=0&id=1b0af5ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0af5ee",
  null
  
)

export default component.exports